import React, { FC } from 'react';
import Modal from '@/src/components/clean/Modal/Modal';
import { AiFillWarning } from 'react-icons/ai';
import style from './createEventButton.module.scss';
type Props = {
  onClose: () => void;
  onConfirm: () => void;
  message?: string;
};
const CreateEventMobileModal: FC<Props> = ({ onConfirm, onClose, message }) => {
  return (
    <Modal
      title={'VISIT KLıC'}
      width={'56.25rem'}
      onClose={onClose}
      onConfirm={onConfirm}
      loading={false}
      confirmLabel={'OK'}
      isOpen={true}
      hideHeader={true}
      icon={<AiFillWarning color={'red'} />}
      confirmStyle={'primary-v2'}
      hasCloseButton={false}
      footerClass={style['footer-center']}
    >
      <div className={style['body-content']}>
        {message
          ? message
          : 'To create an event on KLıC, please visit the Desktop Site'}
      </div>
    </Modal>
  );
};

export default CreateEventMobileModal;
